export default __webpack_public_path__ + "static/media/challenges_01.9c2f0bfd.svg";